export const formatTimeStampToObject = (
  timestamp: number,
  nanos: number = 0
) => ({
  seconds: Math.floor(timestamp / 1000),
  nanos
})
